import * as types from '../actions/types'
import Immutable from 'immutable'
import diff from 'immutablediff'
import patch from 'immutablepatch'



import {
    isPrimitive,
    cotizacion,
    foro
} from '../utils/helpers'


const INITIAL_STATE = Immutable.fromJS({
    id: null,
    estado: 0,
    solicitud: {},
    aprobadores: {},
    unchaged: {},
    btnSaveDisabled: true,
    btnRComprasDisabled: true,
    modified: [],
	modalAddCotizacion: {
		title: '',
		mode: '',
		show: false,
		data: null,
		btnDisabled: false
    },
	modalAddReservacion: {
		title: '',
        show: false,
        index: null,
		data: null,
		btnDisabled: false
    },

    addModificacion: false,

    comentario: {
        id: null,
        texto: null,
        btnSendDisabled: false
    }
})

export default function (state = INITIAL_STATE, action) {

    let index

	switch (action.type) {

        case types.ADICIONAR_MODIFICACION_SOLICITUD_HOTELES:
            state = state.set('modified', state.get('modified').filter(x => x.get('entity') + x.get('attribute') + x.get('id') !== action.payload.entity + action.payload.attribute + action.payload.id))
            state = state.update('modified', list => list.push(Immutable.fromJS(action.payload)))
            state = state.set('btnSaveDisabled', state.get('modified').count() === 0)
            return state


        case types.OBTENER_SOLICITUD_HOTELES:
			state = state.set('id', action.payload.solicitud.id)
			state = state.set('estado', action.payload.solicitud.estado)
            state = state.set('solicitud', Immutable.fromJS(action.payload.solicitud))
            state = state.set('unchaged', Immutable.fromJS(action.payload.solicitud))
            state = state.set('aprobadores', Immutable.fromJS(action.payload.aprobadores))
            if (action.payload.reset !== false) {
                state = state.set('modified', INITIAL_STATE.get('modified'))
            }
            state = state.set('btnSaveDisabled', state.get('modified').count() === 0)


            state.getIn(['solicitud', 'cotizaciones']).map((c,i) => {
                c.get('aprobaciones').map((a,j) => {
                    state = state.setIn(['solicitud', 'cotizaciones', i, 'aprobaciones', j, 'selected'], false)
                })
            })

            return state


		case types.MOSTRAR_MODAL_ADICIONAR_COTIZACION_HOTELES:
			state = state.setIn(['modalAddCotizacion', 'show'], action.payload.show)
            if (action.payload.show) {
                state = state.setIn(['modalAddCotizacion', 'title'], action.payload.title)
                state = state.setIn(['modalAddCotizacion', 'mode'], action.payload.mode)
                if (action.payload.mode === 'create') {
                    state = state.setIn(['modalAddCotizacion', 'data'], Immutable.fromJS(cotizacion()))
                } else if (action.payload.mode === 'edit') {
                    state = state.setIn(['modalAddCotizacion', 'data'], state.getIn(['solicitud', 'cotizaciones', action.payload.index]))
                }
            } else {
                state = state.set('modalAddCotizacion', INITIAL_STATE.get('modalAddCotizacion'))
            }


            return state

        case types.MOSTRAR_MODAL_ADICIONAR_RESERVACION:
            state = state.setIn(['modalAddReservacion', 'show'], action.payload.show)

            if (action.payload.show) {
                state = state.setIn(['modalAddReservacion', 'title'], action.payload.title)
                state = state.setIn(['modalAddReservacion', 'index'], action.payload.index)
                state = state.setIn(['modalAddReservacion', 'data'], state.getIn(['solicitud', 'hotel', 'huespedes', action.payload.index]))

            } else {
                state = state.set('modalAddReservacion', INITIAL_STATE.get('modalAddReservacion'))
            }
            return state



        case types.MODIFICAR_INPUTS_SOLICITUD_HOTELES1:

            if (isPrimitive(action.payload.value)) {
    			state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
            } else {
                if (action.payload.immutable === false) {
                    state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
                } else {
                    state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
                }
            }

            if (action.payload.path.split('.').slice(-1)[0] == 'responsable_compras' || action.payload.path.split('.').slice(-1)[0] == 'solicitante') {
                state = state.set('btnRComprasDisabled', false)
            }

            // if (action.payload.path.split('.').slice(-1)[0] == 'rubro_id') {
            //     let newPath = action.payload.path.split('.')
            //     newPath = newPath.splice(0, newPath.length-1)
            //     if (newPath[newPath.length-1] == 'pivot') {
            //         state = state.setIn([...newPath, 'selected'], true)
            //     }
            // }

            return state


        case types.ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_HOTELES:
            state = state.setIn(`${action.payload.path}`.split('.'), action.payload.data)
            return state


        case types.ADICIONAR_COTIZACION_HOTELES:
            index = state.getIn(['solicitud', 'cotizaciones']).findIndex(x => x.get('guid')==action.payload.data.get('guid'))
            if (index == -1) {
                index = state.getIn(['solicitud', 'cotizaciones']).count()
            }
            state = state.setIn(['solicitud', 'cotizaciones', index], action.payload.data)
            return state

        case types.MODIFICAR_RESERVACION:
            state = state.setIn(['solicitud', 'hotel', 'huespedes', action.payload.index], action.payload.data)
            return state


		case types.DESHABILITAR_BOTON_SALVAR_SOLICITUD_HOTELES:
			state = state.set('btnSaveDisabled', action.payload)
            return state


        case types.ACTUALIZAR_SOLICITUD_HOTELES:
            const ops = diff(state.get('solicitud'), Immutable.fromJS(action.payload.solicitud))
            state = state.set('solicitud', patch(state.get('solicitud'), ops))
            if (ops.filter(x => x.get('path') === '/estado').count() === 1) {
                state = state.set('estado', state.getIn(['solicitud', 'estado']))
            }
            state = state.set('aprobadores', Immutable.fromJS(action.payload.aprobadores))
            state = state.set('btnRComprasDisabled', true)
            state = state.set('comentario', INITIAL_STATE.get('comentario'));
            return state


        case types.SELECCIONAR_APROBACION_SOLICITUD_HOTELES:
            state = state.updateIn(['aprobadores', action.payload.indexAprobador, 'aprobaciones'], list => list.map(x => x.set('estado', 1)))
            state = state.setIn(['aprobadores', action.payload.indexAprobador, 'aprobaciones', action.payload.indexAprobacion, 'estado'], 2)
            return state


        case types.REMOVER_COTIZACION_HOTELES:
            state = state.updateIn(['solicitud', 'cotizaciones'], list => list.filter(x => !x.get('selected')))
            return state

        case types.EDITAR_COMENTARIO_SOLICITUD_HOTELES1:
            index = state.getIn(['solicitud','foros']).findIndex(c => c.get('id') === action.payload.id)
            state = state.setIn(['comentario','id'], action.payload.id)
            state = state.setIn(['comentario','texto'], state.getIn(['solicitud', 'foros', index, 'comentario']))
            return state

        case types.DESHABILITAR_BOTON_ENVIAR_COMENTARIO_HOTELES1:
            state = state.setIn(['comentario','btnSendDisabled'], action.payload)
            return state

        case types.ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_HOTELES1:
            state = state.setIn(['solicitud','foros'], Immutable.fromJS(action.payload.foros))
            state = state.set('comentario', INITIAL_STATE.get('comentario'));
            return state

       	default:
            return state

	}
}



// WEBPACK FOOTER //
// ./src/reducers/solicitudhoteles.js